<template>
    <div class="form-content">
        <h1>Odhlásenie zo systému</h1>

        <span class="text-mute">
            Ďakujeme za návštevu
        </span>
    </div>
</template>

<script>
    export default {
        data: () => ({

            }),
        mounted() {
            this.logout();
        },
        watch: {
            $router: "logout"
        },
        methods: {
            logout() {
                var self = this;
                setTimeout(() => {
                    self.$api.login.logout();
                }, 3000);
            }
        }

    };
</script>



// WEBPACK FOOTER //
// src/public_app/pages/Logout.vue